"use client";

import Image from "next/image";
import { MdVerified } from "react-icons/md";

import { VerifiedType } from "@/backend/focus";
import { cn } from "@/utils/lib";

type XAvatarProps = {
  fallback?: string;
  verified?: VerifiedType;
} & React.ComponentProps<typeof Image>;

const verifiedColorMap = {
  [VerifiedType.Blue]: "text-blue-400",
  [VerifiedType.Gold]: "text-yellow-400",
  [VerifiedType.Business]: "text-yellow-400",
};

const XAvatar = ({
  fallback = "/assets/app-default-profile.png",
  verified = VerifiedType.None,
  ...props
}: XAvatarProps) => {
  return (
    <figure className="relative">
      {/* It'll come from props */}
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <Image
        {...props}
        onError={(e) => {
          e.currentTarget.srcset = fallback;
        }}
      />
      {verified !== VerifiedType.None && (
        <div className="bg-white">
          <MdVerified
            className={cn(
              `
                absolute right-[-4px] bottom-[-4px] fill-primary
                stroke-background stroke-1 text-xl
                [&>path:first-child]:hidden
              `,
              verifiedColorMap[verified],
            )}
          />
        </div>
      )}
    </figure>
  );
};

export default XAvatar;
